export enum BasketStatus {
  Open = 'open',
  PaymentPending = 'paymentpending',
  PaymentAuthorized = 'paymentauthorized',
  Canceled = 'canceled'
}
